// https://app.growthbook.io/features/pen-4874_v1
export const CM_HERO_IS_A_TRAILER_FLAG = 'pen-4874_v1'
